import { createStore } from 'react-hooks-global-state';

/* const Action =
  | { type: 'increment' }
  | { type: 'decrement' }
  | { type: 'setFirstName'; firstName: string }
  | { type: 'setLastName'; lastName: string }
  | { type: 'setAge'; age: number }; */

  export const { dispatch, useGlobalState } = createStore(
    (state, action) => {
      switch (action.type) {
        case 'setInstrument': return {
          ...state,
          instrument: action.instrument,
        };
        case 'increment': return {
          ...state,
          count: state.count + 1,
        };
        case 'decrement': return {
          ...state,
          count: state.count - 1,
        };
        case 'setFirstName': return {
          ...state,
          person: {
            ...state.person,
            firstName: action.firstName,
          },
        };
        case 'setLastName': return {
          ...state,
          person: {
            ...state.person,
            lastName: action.lastName,
          },
        };
        case 'setAge': return {
          ...state,
          person: {
            ...state.person,
            age: action.age,
          },
        };
        case 'toggleTheme': return {
          ...state,
          theme: state.theme=='light'?'dark':'light',
        };
        default: return state;
      }
    },
    {
      instrument: 'C',
      instrumentClef: 'g',
      theme: 'light',
      count: 0,
      person: {
        age: 0,
        firstName: '',
        lastName: '',
      },
      // Set by whichever page has meaningful in-app context (e.g. which
      // step of a Song/Fact the user is on) so BugReportButton can include
      // it in a report regardless of which page it's rendered from.
      pageContext: null,
    },
  );